import React, {Component} from 'react'

import { withRouter } from "react-router-dom";

class Link extends Component {

  href = '';
  navigate = (event) =>  {

      // Internal link?
      let href = this.refs.el.getAttribute('href');
      let hasExtension = (href.indexOf('.') != -1);
      let internalLink = (href.indexOf('/') == 0);
      if(internalLink && !hasExtension){
        
        event.preventDefault();
        this.href = href;

        if(this.props.before){

            this.props.before(this.loadHref,this.refs.el);

        }else{

            this.loadHref();

        }

      }
    
  }

  isExternal = (href) => {

      let hasExtension = (href.indexOf('.') != -1);
      let internalLink = (href.indexOf('/') == 0);
      let isEmail = (href.indexOf('@') != -1);

      if((internalLink && !hasExtension) || isEmail){
        
        return false;

      }else{
        return true;
      }

  }

  loadHref = () => {

      this.props.history.push(this.href);

  }

  render () {

      let {className} = this.props;

      if(this.props.navlink){

          let exact =  (this.props.hasOwnProperty('exact')) ? this.props.exact : (this.props.to == '/');
          let isActive = (exact) ? window.location.pathname == this.props.to : window.location.href.match(this.props.to);

          className += ' ';
          className += (isActive) ? 'is-active' : 'is-inactive';

      }

      let autoTarget = null;

      if(!this.props.hasOwnProperty('autotarget') || this.props.autotarget){

          autoTarget = (this.isExternal(this.props.to)) ? '_blank' : null;

      }

      return (
        <a href={this.props.to} ref={'el'} target={(this.props.target || autoTarget)} onClick={this.navigate} className={className}>{this.props.children}</a>
        )

  }

}

export default withRouter(Link);



// WEBPACK FOOTER //
// ./src/js/_core/components/Link/Link.jsx